
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokegetAllProgram, getAllOffCycleByByProgram } from '@/utils/admin/task_management_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokegetSkillProf } from '@/utils/admin/assign_proxy_service';
// eslint-disable-next-line
import router from '@/router';
import { fetchOffCycle } from '@/utils/admin/createOffCycle';
import axios from '@/plugins/axios';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'OffcycleDashboard',
  components: {},

  setup() {
    const programDetails = ref();
    const renderReady = ref(true);
    const taskDetails = ref();
    const newTaskDetails = ref();
    const showIsOffcycleActive = ref(true);
    const taskCheckOne = ref([]);
    const selectedProgram = ref('Select Program');
    const checkedTaskId = ref();
    const checkedLinkedTaskId = ref();
    const userRole = ref();
    const showScreen = ref(true);
    const errorMessage = ref();
    const successMessage = ref();
    const skills = ref();
    const proficiency = ref();
    const selectedSkill = ref('Select Skill');
    const selectedProficiency = ref('Select Proficiency');
    const showSkillProf = ref(false);
    const searchBtn = ref(false);
    const showInactiveButton = ref(false);
    let taskData = {};
    const skillErrorMessage = ref();
    const proficiencyError = ref();
    const offCycleDetailsBtnShow = ref(false);
    const taskcheckedOne = () => {
      taskCheckOne.value = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showTaskBtn = (event: any, learnerTaskId: any, isOffCycleActive: number, LinkedTaskId: any) => {
      const cb = event.target.checked;
      if (cb === true) {
        checkedTaskId.value = learnerTaskId;
        checkedLinkedTaskId.value = LinkedTaskId;
        offCycleDetailsBtnShow.value = true;
        console.log('isOffCycleActive', isOffCycleActive);
      } else {
        offCycleDetailsBtnShow.value = false;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const filterTaskDetails = async (show: boolean) => {
      if (show) {
        newTaskDetails.value = taskDetails.value.filter((task) => Number(task.is_offcycle_active) === 1);
      } else {
        newTaskDetails.value = taskDetails.value.filter((task) => Number(task.is_offcycle_active) !== 1);
      }
      showIsOffcycleActive.value = show;
    };
    const getTaskDetails = async () => {
      renderReady.value = false;
      taskDetails.value = await getAllOffCycleByByProgram('/getAllOffcycleByProgram', taskData);
      await filterTaskDetails(true);
      console.log('taskDetails.value ', taskDetails.value);
      renderReady.value = true;
    };
    const exportOffcycle = async () => {
      try {
        const data = {};
        if (selectedProgram.value !== 'Select Program') {
          Object.assign(data, { program_id: selectedProgram.value });
          if (selectedSkill.value !== 'Select Skill') {
            Object.assign(data, { skill_id: selectedSkill.value });
            if (selectedProficiency.value !== 'Select Proficiency') {
              Object.assign(data, { proficiency_id: selectedProficiency.value });
            }
          }
        }
        await fetchOffCycle('/offcycle/fetch?action=report', data);
        successMessage.value = 'The report is being processed. You should get that over email in next 15 minutes';
        setTimeout(() => {
          successMessage.value = null;
        }, 6000);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log('err.response?.data', err.response?.data);
          renderReady.value = true;
          errorMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        }
      }
    };
    const searchTask = async () => {
      showInactiveButton.value = true;
      taskData = {};
      if (selectedProgram.value !== 'Select Program') {
        Object.assign(taskData, { program_id: selectedProgram.value });
        console.log('task data', taskData);
        if (selectedSkill.value !== 'Select Skill') {
          Object.assign(taskData, { skill_id: selectedSkill.value });
          console.log('task data', taskData);
          if (selectedProficiency.value !== 'Select Proficiency') {
            Object.assign(taskData, { proficiency_id: selectedProficiency.value });
            console.log('task data', taskData);
          }
        }
        if (selectedProgram.value === 'infinity') {
          if (selectedSkill.value === 'Select Skill') {
            skillErrorMessage.value = 'Please Select Skill';
            setTimeout(() => {
              skillErrorMessage.value = null;
            }, 6000);
            return;
          }
          if (selectedProficiency.value === 'Select Proficiency') {
            proficiencyError.value = 'Please Select Proficiency';
            setTimeout(() => {
              proficiencyError.value = null;
            }, 6000);
            return;
          }
        }
        await getTaskDetails();
      } else {
        // renderReady.value = false;
        taskDetails.value = {};
        newTaskDetails.value = {};
        showInactiveButton.value = false;
        // taskDetails.value = await getAllOffCycleByByProgram('/getAllOffcycleByProgram', {});
        // await filterTaskDetails(true);
        // renderReady.value = true;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProgram = async (e: any) => {
      renderReady.value = false;
      localStorage.setItem('program', e.target.value);

      localStorage.removeItem('skill');
      localStorage.removeItem('proficiency');
      selectedProgram.value = e.target.value;
      if (selectedProgram.value !== 'Select Program') {
        searchBtn.value = true;
        if (selectedProgram.value === 'infinity') {
          selectedSkill.value = 'Select Skill';
          selectedProficiency.value = 'Select Proficiency';
          showSkillProf.value = true;
        } else {
          showSkillProf.value = false;
          selectedSkill.value = '';
          selectedProficiency.value = '';
        }
      } else {
        localStorage.setItem('program', 'Select Program');
        // searchBtn.value = false;
        showInactiveButton.value = false;
        showSkillProf.value = false;
      }
      renderReady.value = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      localStorage.setItem('skill', e.target.value);
      selectedSkill.value = e.target.value;
      if (selectedSkill.value === 'Select Skill') {
        localStorage.removeItem('skill');
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProficiency = async (e: any) => {
      localStorage.setItem('proficiency', e.target.value);
      selectedProficiency.value = e.target.value;
      if (selectedProficiency.value === 'Select Proficiency') {
        localStorage.removeItem('proficiency');
      }
    };
    const getProgram = async () => {
      renderReady.value = false;
      programDetails.value = await invokegetAllProgram('/cache?cache=program');
      console.log(programDetails.value);
      renderReady.value = true;
    };
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };

    const viewOffCycleDetails = () => {
      router.push({ name: 'SolidifyAdministrationOffCycleDetails', query: { learner_task_id: checkedTaskId.value } });
    };
    const createOffcycle = () => {
      console.log('selectedProgram.value inside create offcycle', selectedProgram.value);
      console.log('selectedSkill.value inside create offcycle', selectedSkill.value);
      console.log('selectedProficiency.value inside create offcycle', selectedProficiency.value);
      if ((selectedProgram.value === 'infinity' || selectedProgram.value === 'Select Program') && (selectedSkill.value === 'Select Skill' || selectedProficiency.value === 'Select Proficiency' || !selectedProficiency.value)) {
        errorMessage.value = 'Please select Program, and in case of infinity please select skill and proficiency';
        setTimeout(() => {
          errorMessage.value = null;
        }, 6000);
      } else {
        console.log('selectedProgram.value', selectedProgram.value);
        if (selectedProgram.value !== 'infinity') {
          router.push({ name: 'SolidifyAdministrationCreateOffCycles', query: { Program_id: selectedProgram.value } });
        } else {
          router.push({ name: 'SolidifyAdministrationCreateOffCycles', query: { Program_id: selectedProgram.value, skill_id: selectedSkill.value, proficiency_id: selectedProficiency.value } });
        }
      }
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');

      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access') || userRole.value.includes('Program Admin')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
      localStorage.removeItem('programId');
      localStorage.removeItem('programName');
      localStorage.removeItem('linkedTaskId');
      localStorage.removeItem('skillId');
      localStorage.removeItem('skillName');
      localStorage.removeItem('proficiencyId');
      localStorage.removeItem('proficiencyName');
      localStorage.removeItem('taskName');
      localStorage.removeItem('taskType');
      await getProgram();
      await getSkillandProf();
      if (localStorage.getItem('program')) {
        selectedProgram.value = localStorage.getItem('program') || 'Select Program';
        Object.assign(taskData, { program_id: localStorage.getItem('program') });
        if (localStorage.getItem('skill')) {
          selectedSkill.value = localStorage.getItem('skill') || 'Select Skill';
          Object.assign(taskData, { skill_id: localStorage.getItem('skill') });
          if (localStorage.getItem('proficiency')) {
            selectedProficiency.value = localStorage.getItem('proficiency') || 'Select Proficiency';
            Object.assign(taskData, { proficiency_id: localStorage.getItem('proficiency') });
          }
        }
      }

      console.log('Local Storage Value', taskData);
      if (localStorage.getItem('program') && localStorage.getItem('program') !== 'Select Program') {
        console.log('inside onbefore');
        try {
          await getTaskDetails();
        } catch (error) {
          if (axios.isAxiosError(error)) {
            const err = error as AxiosError;
            console.log('err.response?.data', err.response?.data);
            renderReady.value = true;
            errorMessage.value = (err.response?.data as { message: string })?.message;
            console.log(`errorMessage.value ${errorMessage.value}`);
            setTimeout(() => {
              errorMessage.value = null;
            }, 6000);
          }
        }
      }
      searchBtn.value = true;
      if (selectedProgram.value !== 'Select Program') {
        showInactiveButton.value = true;
      }
      if (selectedProgram.value === 'infinity') {
        showSkillProf.value = true;
      } else {
        showSkillProf.value = false;
      }
    });
    return {
      renderReady,
      programDetails,
      getSelectedProgram,
      taskDetails,
      taskCheckOne,
      taskcheckedOne,
      checkedTaskId,
      showTaskBtn,
      showScreen,
      selectedProgram,
      errorMessage,
      successMessage,
      getTaskDetails,
      skills,
      proficiency,
      getSelectedSkill,
      getSelectedProficiency,
      showSkillProf,
      searchBtn,
      selectedSkill,
      selectedProficiency,
      searchTask,
      exportOffcycle,
      offCycleDetailsBtnShow,
      viewOffCycleDetails,
      createOffcycle,
      showIsOffcycleActive,
      newTaskDetails,
      filterTaskDetails,
      userRole,
      showInactiveButton,
      skillErrorMessage,
      proficiencyError,
    };
  },
});
